module.exports = __webpack_public_path__ + "img/hk.d38b6d18.png";